import Model, { ID, Integer, JsonObject, MODEL_LEVEL } from 'src/models/model'
import Tax from 'src/models/order/Tax'

export default class ItemClass extends Model {
  static name = 'ItemClass'

  static isConfiguration = true

  static deletable = true

  static versioned = true

  static level = MODEL_LEVEL.CIRCUIT

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Concession]

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      displayOrder: {
        type: Integer,
        default: 100
      },
      name: {
        type: String
      },
      description: {
        type: String
      },
      color: {
        type: String
      },
      taxes: {
        type: [Tax],
        default: () => ([]),
        reference: true
      },
      includeInPerCap: {
        type: Boolean,
        required: false,
        default: true
      },
      polarisDataStreamId: {
        type: String,
        default: null,
        excludeFromDefault: true
      },
      itemCounts: {
        type: JsonObject,
        output: true,
        excludeFromDefault: true
      }
    }
  }
}
